class ReceivedAsSuggestion {
    constructor(data) {
        this.take = 10;
        this.page = data.page;
    }

    get() {
        this.buildFilters();
        return this.filters;
    }

    buildFilters() {
        this.filters = {
            'user_id': App.user.id,
            'gradually': false,
            'published': false,
            'only_received_as_suggestion': true,
            'take': this.take,
            'skip': (this.page - 1) * this.take,
            'add_separator': 'song_received_as_suggestion_at',
            'favorites_first': true,
            'order_recent_by_suggest_month': true,
        };
    }
}

export default ReceivedAsSuggestion;
